module.exports = __webpack_public_path__ + "static/media/2019_4G8A7369.40386350.jpg";